"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.UpdateSingleton__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "singleton",
                type: "address"
            },
        ],
        name: "ChangedMasterCopy",
        type: "event"
    },
    {
        inputs: [],
        name: "self",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "targetSingleton",
                type: "address"
            },
        ],
        name: "update",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "0x60a060405234801561001057600080fd5b50306080526080516102f9610036600039600081816055015261015f01526102f96000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c80631c1b87721461003b5780637104ddb214610050575b600080fd5b61004e610049366004610286565b6100a0565b005b6100777f000000000000000000000000000000000000000000000000000000000000000081565b60405173ffffffffffffffffffffffffffffffffffffffff909116815260200160405180910390f35b73ffffffffffffffffffffffffffffffffffffffff8116610148576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602260248201527f496e76616c69642073696e676c65746f6e20616464726573732070726f76696460448201527f656400000000000000000000000000000000000000000000000000000000000060648201526084015b60405180910390fd5b73ffffffffffffffffffffffffffffffffffffffff7f000000000000000000000000000000000000000000000000000000000000000016300361020d576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152603060248201527f4d6967726174696f6e2073686f756c64206f6e6c792062652063616c6c65642060448201527f7669612064656c656761746563616c6c00000000000000000000000000000000606482015260840161013f565b600080547fffffffffffffffffffffffff00000000000000000000000000000000000000001673ffffffffffffffffffffffffffffffffffffffff83169081179091556040519081527f75e41bc35ff1bf14d81d1d2f649c0084a0f974f9289c803ec9898eeec4c8d0b89060200160405180910390a150565b60006020828403121561029857600080fd5b813573ffffffffffffffffffffffffffffffffffffffff811681146102bc57600080fd5b939250505056fea2646970667358221220c320909f8b84b997f7e974dff71f9816411a72d71eb404294986c596190fc6bf64736f6c63430008110033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var UpdateSingleton__factory = /** @class */ (function (_super) {
    __extends(UpdateSingleton__factory, _super);
    function UpdateSingleton__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    UpdateSingleton__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    UpdateSingleton__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    UpdateSingleton__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    UpdateSingleton__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    UpdateSingleton__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    UpdateSingleton__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    UpdateSingleton__factory.bytecode = _bytecode;
    UpdateSingleton__factory.abi = _abi;
    return UpdateSingleton__factory;
}(ethers_1.ContractFactory));
exports.UpdateSingleton__factory = UpdateSingleton__factory;
